module.exports = __webpack_public_path__ + "static/media/gloria.07e5e46b.jpeg";